import { render, staticRenderFns } from "./otodetstrter.vue?vue&type=template&id=302dc6e0&scoped=true&"
import script from "./otodetstrter.vue?vue&type=script&lang=js&"
export * from "./otodetstrter.vue?vue&type=script&lang=js&"
import style0 from "./otodetstrter.vue?vue&type=style&index=0&id=302dc6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302dc6e0",
  null
  
)

export default component.exports